module.exports = __webpack_public_path__ + "static/img/coins.468570e9.webp";